/**
 * Hook utilitaire — Mode démonstration (toutes versions)
 *
 * Retourne `true` si l'utilisateur connecté est un compte de démonstration,
 * qu'il s'agisse de la version Courtier ou Compagnie.
 * Détection : présence d'un `demo_mode` OU e-mail se terminant par "@pitboard.demo".
 */
import { useAuth } from '../components/Auth/AuthContext';

export const useIsDemo = () => {
  const { user } = useAuth();
  if (!user) return false;
  if (user.demo_mode) return true;
  return typeof user.email === 'string' && user.email.toLowerCase().endsWith('@pitboard.demo');
};
